export const addDecimal = (value: number, maxPlaces = 2) => {
	if (value % 1 === 0) {
		return value;
	}
	return value.toFixed(maxPlaces);
};

export const roundNumber = (number: number) => Math.round(number * 100) / 100;
